import { render } from "./DNAMatchNotification.vue?vue&type=template&id=fcd0b526&scoped=true"
import script from "./DNAMatchNotification.vue?vue&type=script&lang=js"
export * from "./DNAMatchNotification.vue?vue&type=script&lang=js"

import "./DNAMatchNotification.vue?vue&type=style&index=0&id=fcd0b526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcd0b526"]])

export default __exports__